<template>
  <section class="trust-footer" id="trust">
    <div class="container">
      <h2>{{ $t('trustFooter.title') }}</h2>
      <ul class="trust-items">
        <li v-for="(item, i) in $tm('trustFooter.items')" :key="i">
          <span class="check-icon">✓</span>
          <span>{{ $rt(item) }}</span>
        </li>
      </ul>
    </div>
  </section>
</template>

<style scoped>
.trust-footer {
  padding: 60px 20px;
  background: linear-gradient(135deg, var(--primary-dark) 0%, var(--primary-color) 100%);
  color: white;
  text-align: center;
}

.container {
  max-width: 800px;
  margin: 0 auto;
}

h2 {
  font-size: 2rem;
  margin-bottom: 30px;
}

.trust-items {
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
}

.trust-items li {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 1.1rem;
  opacity: 0.95;
}

.check-icon {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 0.9rem;
}

@media (max-width: 768px) {
  .trust-footer {
    padding: 40px 15px;
  }
  h2 {
    font-size: 1.5rem;
  }
  .trust-items li {
    font-size: 0.95rem;
  }
}
</style>
